export default "/_next/static/images/3290e72947058d26b77659fbf7696b8d.jpg";